import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { FriendshipRaceLogin } from '../../../models/types';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-friendship-race-prijava',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './friendship-race-prijava.component.html',
  styleUrl: './friendship-race-prijava.component.scss'
})
export class FriendshipRacePrijavaComponent {
  raceForm: FormGroup;
  racers: FriendshipRaceLogin[] = [];
  @Input() isOrgAdmin: boolean = false;

  constructor(private fb: FormBuilder, private organisationService: OrganisationServiceService) {
    this.raceForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      yearOfBirth: [null, Validators.required],
      sex: ['', Validators.required],
      address: ['', Validators.required],
      club: [''],
      citizenship: ['', Validators.required],
      kids: [false],
      kidsLength: [null],
      longRace: [false],
      shortRace: [false],
    }, { validators: this.atLeastOneRaceSelected });
  }

  private atLeastOneRaceSelected(group: FormGroup): { [key: string]: boolean } | null {
    const kids = group.get('kids')?.value;
    const longRace = group.get('longRace')?.value;
    const shortRace = group.get('shortRace')?.value;

    if (kids || longRace || shortRace) {
      return null; // Valid
    }
    return { atLeastOneRaceRequired: true }; // Invalid
  }

  ngOnInit(): void {
    this.getRacers();
  }

  onSubmit(): void {
    if (this.raceForm.valid) {
      this.organisationService.enrollInFriendshipRace(this.raceForm.value).subscribe({
        next: (response) => {
          Swal.fire({
            icon: 'success',
            title: 'Uspešna prijava',
            text: 'Uspešno ste se prijavili na Tek prijateljstva!',
          }).then(() => {
            window.location.reload();
          });
        },
        error: (error) => {
          console.error('Error:', error);
          Swal.fire({
            icon: 'error',
            title: 'Napaka',
            text: 'Prišlo je do napake pri prijavi na Tek prijateljstva! Prosimo, poskusite znova kasneje.',
          });
        },
      });
    }
  }


  getRacers(): void {
    this.organisationService.getFriendshipRaceRacers().subscribe({
      next: (response) => {
        this.racers = response.racers;
      },
      error: (error) => {
        console.error('Error:', error);
      },
    });
  }
      
    // Trigger CSV download using the service
    downloadCSV(): void {
      this.organisationService.downloadFriendshipRaceCSV().subscribe({
        next: (response: Blob) => {
          // Create a URL for the Blob response and trigger the download
          const url = window.URL.createObjectURL(response);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'tekPrijateljstvaTekmovalci.csv'; // Filename of the CSV
          link.click();
          window.URL.revokeObjectURL(url); // Clean up the URL object
        },
        error: (error) => {
          console.error('Error downloading CSV:', error);
        },
      });
    }

}
